import React, { useState } from 'react';
import { Box } from '@mui/material';
import { withTranslation } from 'react-i18next';

import {
  Header,
  Tabs,
  ModalContainer,
} from '@core/dashboard/components/PopoverModal';

import ScrollableContainer from '@components/ScrollableContainer';
import { useMytaverseEvent } from '@core/dashboard/providers';
import GamecastStats from '@core/dashboard/components/DashboardContent/GameCast/GamecastStats';
import DevicesSettingsSound from '@core/devices/components/DevicesSettings/DevicesSettingsSound';
import DevicesSettingsVideo from '@core/devices/components/DevicesSettings/DevicesSettingsVideo';
import SettingsGeneral from './SettingsGeneral';

import { ProfileScreensEnum } from '@components/UserProfileModalNew/interfaces';

import { ISettings } from './interfaces';
import { useStyles } from './styles';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';

const Settings = ({ onClose, setActiveScreen, t: translate }: ISettings) => {
  const { canSpeak } = useMytaverseEvent();
  const { cameraList } = useCommunications();

  const classes = useStyles();

  const [settingsTab, setSettingsTab] = useState('general');

  return (
    <ModalContainer
      header={
        <>
          <Header
            onClose={onClose}
            text={translate('settingsModal.settings')}
            onBack={() => setActiveScreen(ProfileScreensEnum.DEFAULT)}
            isBig
            testId="user-profile"
          />
          <Tabs
            active={settingsTab}
            onChange={(_: React.SyntheticEvent, tab: any) =>
              setSettingsTab(tab)
            }
            sx={classes.tabs}
            tabs={[
              { label: translate('settingsModal.sound'), value: 'sound' },
              ...(canSpeak && cameraList.length > 0
                ? [
                    {
                      label: translate('settingsModal.camera'),
                      value: 'camera',
                    },
                  ]
                : []),
              { label: translate('settingsModal.general'), value: 'general' },
              { label: translate('settingsModal.stats'), value: 'stats' },
            ]}
          />
        </>
      }
      isScrollable={true}
      hasTabs
    >
      {(() => {
        switch (settingsTab) {
          case 'sound':
            return <DevicesSettingsSound />;
          case 'camera':
            return <DevicesSettingsVideo />;
          case 'stats':
            return <GamecastStats />;
          default:
            return <SettingsGeneral />;
        }
      })()}
    </ModalContainer>
  );
};

export default withTranslation()(Settings);
